export class AdminAnnouncement {
    constructor(
      public id?: number,
      public title?: string,
      public description?: string,
      public validFromDt?: string,
      public validToDt?: string,
      public audience?: string,
      public typeCd?: string,
      public priorityCd?: string,
      public countyCd?: string,
      public recordVersion?:number,
      public selectProvider?: string
    ){
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/model/admin-announcement.model.ts